import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DeviceSessionsService } from 'src/app/shared/services/device-sessions.service';
import {
  AssociateUser,
  DissociateUser,
  ExtendAssociation,
  DeviceSessionsList,
  AssociateOrDissociateUser
} from "src/app/shared/models/device-sessions";
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { ToastrService } from 'ngx-toastr';


export enum PopupActionTypes {
  ASSOCIATE = 'associate',
  DISSOCIATE = 'dissociate',
  EXTEND = 'extend'
}

enum Headers {
  ASSOCIATE = 'Associate Device to User',
  DISSOCIATE = 'Dissociate User',
  EXTEND = 'Extend Time'
}

enum ButtonNames {
  ASSOCIATE = 'Associate',
  DISSOCIATE = 'Yes',
  EXTEND = 'Extend'
}

@Component({
  selector: 'app-action-popup',
  templateUrl: './action-popup.component.html',
  styleUrls: ['./action-popup.component.scss']
})
export class ActionPopupComponent implements OnInit,OnChanges {

  @Input() actionType!: PopupActionTypes;
  @Input() sessionData!: DeviceSessionsList;
  @Output() emitCloseEvent = new EventEmitter();

  headerName:string='';
  btnName:string='';
  associatedUser:string='';
  timeLeft:any;
  messagePopup:any;
  message:any;
  showpopupforassociate:boolean = false;
  lmsUserId:any;
  requireduser:boolean;
  requiredtime:boolean;
  associateresponse:any;
  disassociateResponse:any;
  extendResponse: any;
  timeInMin:any;
  isDissociate:boolean=false;
  isLoading: boolean = false;
  showLoader:boolean = false;
  errorMessage: any;
  deviceForm=new FormGroup({
    lmsUser:new FormControl(''),
    timeInMin:new FormControl('')
  });
  currentUser!: string;
  associatedDevice: any;
  selectDeviceId: string = "";

  constructor(
    private deviceSessionsService: DeviceSessionsService,
    private toasterService: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.sessionStorageService.getUsername();
    this.associatedUser = this.sessionData.associatedUser;
    this.timeLeft = this.sessionData.timeLeft;

    switch (this.actionType) {
      case PopupActionTypes.ASSOCIATE: 
        this.headerName = Headers.ASSOCIATE;
        this.btnName = ButtonNames.ASSOCIATE;
        break;
      case PopupActionTypes.DISSOCIATE:
        this.isDissociate = true;
        this.headerName = Headers.DISSOCIATE;
        this.btnName = ButtonNames.DISSOCIATE;
        break;
      case PopupActionTypes.EXTEND:
        this.headerName = Headers.EXTEND;
        this.btnName = ButtonNames.EXTEND;
        break;
    }

  }

  ngOnChanges(changes: SimpleChanges): void {}

  closeModal(actionType: string) {
    document.getElementById(actionType).style.display = 'none';
    this.emitCloseEvent.emit(false);
  }
  // deleteData(event: any) {
  //   this.emitDeleteAction.emit(true);
  // }

  onActionClick (name: string) {
    switch (name) {
      case ButtonNames.ASSOCIATE:
        if(!this.deviceForm.value.lmsUser && !this.deviceForm.value.timeInMin){   
          this.requireduser = true;
          this.requiredtime = true;
        }
        else if(!this.deviceForm.value.lmsUser){
          this.requireduser = true;
        }
          else if(!this.deviceForm.value.timeInMin){
            this.requiredtime = true;
          }
        else{
          this.associateUser(true);
          this.requiredtime = false;
          this.requireduser = false;
        }
        break;
      case ButtonNames.DISSOCIATE:
        this.dissociateUser(false);
        break;
      case ButtonNames.EXTEND:
      if(!this.deviceForm.value.timeInMin){
        this.requiredtime = true;
      }else{
        this.extendSession();
      }
        break;
    }
  }
  

  focustime(){
    this.requiredtime = false;
  }

  focususer(){
    this.requireduser = false;
    this.errorMessage = "";
  }

  async associateUser(associate: boolean) {
    this.showLoader = true;
    try {
      if (this.sessionData.associatedUser != null) {
        const payload: AssociateOrDissociateUser = {
          studentId: this.deviceForm.value.lmsUser,
          isAssociated: associate,
          loggedInUser: this.currentUser,
          deviceId: this.sessionData.deviceIdentifier,
          dissociateOldStudentId: this.sessionData.associatedUser,
          timeAllottedInMins: this.deviceForm.value.timeInMin
        }
        this.associateresponse = await this.deviceSessionsService.associate(payload).toPromise();
        if (this.associateresponse.success) {
          console.log(this.associateresponse.message);
          this.toasterService.success("User successfully associated with device");
          this.closeModal(this.actionType);
        }
      } else {
        const payload: AssociateOrDissociateUser = {
          studentId: this.deviceForm.value.lmsUser,
          isAssociated: associate,
          loggedInUser: this.currentUser,
          deviceId: this.sessionData.deviceIdentifier,
          dissociateOldStudentId: null,
          timeAllottedInMins: this.deviceForm.value.timeInMin
        }
        this.associateresponse = await this.deviceSessionsService.associate(payload).toPromise();
        if(this.associateresponse.success){
          console.log(this.associateresponse.message);
          this.toasterService.success("User successfully associated with device");
          this.closeModal(this.actionType);
        }
        }

      } catch (e: any) {
        console.log(e);
        if(e.error.message  == "Mandatory fields missing"){
          console.log(e.error.message);
          this.toasterService.error('All fields are Required');
        }else if(e.status == 422 || e.status == 401){
          this.requireduser = true;
          this.errorMessage = e.error.message;
        }else {
          this.toasterService.error(`${e.error.message}`);
          this.closeModal(this.actionType);
        }
      }
      this.showLoader = false;
  }

  async dissociateUser(associated: boolean) {
  this.isLoading = true;
  try {
    if (this.sessionData.associatedUser !== null) {
      let loggedInUser = this.sessionStorageService.getUsername();
      const payload: AssociateOrDissociateUser = {
        deviceId: this.sessionData.deviceIdentifier,
        studentId: this.sessionData.associatedUser,
        isAssociated: associated,
        loggedInUser: loggedInUser,
        labIdentifier: this.sessionData.labIdentifier,
        dissociateOldStudentId: null,
        timeAllottedInMins: 0
      }
      this.associatedDevice = await this.deviceSessionsService.dissociate(payload).toPromise();
      if (this.associatedDevice.success){
        this.toasterService.success(this.associatedDevice.message);
        this.closeModal(this.actionType);
      }
      }
    } catch (e: any) {
      this.closeModal(this.actionType);
      this.isLoading = false;
      console.log(e);
      if (e.status == 403) {
        // showForbiddenError(this.toasterService);
      }
      else if (e.error.message) {
        console.log(e);
        this.toasterService.error(e.error.message);
      }
      else {
        this.toasterService.error("Server Issue");
      }
    }
  }

  async extendSession() {
    try {
      const payload: ExtendAssociation = {
        username: this.deviceForm.value.lmsUser,
        additionalTimeAllottedInMins: parseInt(this.deviceForm.value.timeInMin),
        loggedInUser: this.currentUser,
        deviceIdentifier: this.sessionData.deviceIdentifier,
        timeLeft: this.sessionData.timeLeft
      }
      this.extendResponse = await this.deviceSessionsService.extend(payload).toPromise();
      if(this.extendResponse.success){
        this.toasterService.success("Device session successfully extended");
        this.closeModal(this.actionType);
      }
    } catch (e: any) {
      console.log(e.error.message);
      this.toasterService.error(e.error.message)
    }
    setTimeout(()=>{                           
      this.closeModal(this.actionType);}, 250);
  }
}
